export default __webpack_public_path__ + "static/media/player-fast-back.d2ad3c16.svg";